import $ from 'jquery';

$(document).on('click', '.analysable', (e) => {
  const railViewId = $('[RailViewID]')[0] === undefined ? window.location.pathname : $('[RailViewID]')[0].attributes.railviewid.value;
  const analyticsId = e.currentTarget.hasAttribute('analytics-id') ? e.currentTarget.getAttribute('analytics-id') : 'help:{{RailViewID}}';
  e.currentTarget.setAttribute('analytics-id', analyticsId.replace(/(:)(.*)/, `$1${railViewId}`));
});
